import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Title,
  Text,
  Grid,
  Center,
  SimpleGrid,
  ThemeIcon,
  useMantineTheme,
} from '@mantine/core';

import * as classes from './FeaturesConHero.module.css';
import ButtonBlock from '../ButtonBlock';
import ICONS_MAP from '../FeatureBlock/IconsMap';


function FeaturesConHero({
  featuresSottotitolo,
  featuresTitolo,
  featuresButtons,
  featuresList,
  stile,
}) {
  const { colors } = useMantineTheme();

  return (
    <Container fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container p="lg">
        <Grid gutter={80} className={classes.outergrid}>
          <Grid.Col span={{ base: 12, md: 5 }} className={classes.outergridcol}>
            <Title className={classes.title} order={2}>
              {featuresTitolo}
            </Title>
            <Text c="dimmed">{featuresSottotitolo}</Text>

            {!!featuresButtons?.length && (
              <Center mt="md" mb="xl">
                <ButtonBlock buttons={featuresButtons} />
              </Center>
            )}
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 7 }} className={classes.outergridcol}>
            <SimpleGrid cols={{ base: 1, xs: 2 }} spacing={30}>
              {featuresList.map(({ bloccoFeatureTitolo, bloccoFeatureIcona, bloccoFeatureDescrizione }, key) => {
                const Ico = ICONS_MAP[bloccoFeatureIcona];

                return (
                  <div key={`feature_hero_${key + 1}`}>
                    {Ico && (
                      <ThemeIcon
                        size={44}
                        radius="md"
                        variant="gradient"
                        gradient={{ deg: 133, from: 'brand', to: 'secondary' }}
                      >
                        <Ico style={{ width: '70%', height: '70%' }} stroke={1.5} />
                      </ThemeIcon>
                    )}
                    <Text fz="lg" mt="sm" fw={500}>
                      {bloccoFeatureTitolo}
                    </Text>
                    <Text c="gray.7" fz="sm">
                      {bloccoFeatureDescrizione}
                    </Text>
                  </div>
                );
              })}
            </SimpleGrid>
          </Grid.Col>
        </Grid>
      </Container>
    </Container>
  );
}

FeaturesConHero.propTypes = {
  featuresTitolo: PropTypes.string,
  featuresSottotitolo: PropTypes.string,
  featuresButtons: PropTypes.array,
  featuresList: PropTypes.array,
};

export default FeaturesConHero;
